/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_MotionInputs */

const en_svchip_motion = /** @type {(inputs: Svchip_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motion`)
};

const ar_svchip_motion = /** @type {(inputs: Svchip_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحركة`)
};

const bn_svchip_motion = /** @type {(inputs: Svchip_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মোশন`)
};

const de_svchip_motion = /** @type {(inputs: Svchip_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antrag`)
};

const es_svchip_motion = /** @type {(inputs: Svchip_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Movimiento`)
};

const fr_svchip_motion = /** @type {(inputs: Svchip_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mouvement`)
};

const pt_svchip_motion = /** @type {(inputs: Svchip_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Movimento`)
};

const zh_svchip_motion = /** @type {(inputs: Svchip_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`运动`)
};

const tr_svchip_motion = /** @type {(inputs: Svchip_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motion`)
};

const ru_svchip_motion = /** @type {(inputs: Svchip_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Движение`)
};

const pl_svchip_motion = /** @type {(inputs: Svchip_MotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruch`)
};

/**
* | output |
* | --- |
* | "Motion" |
*
* @param {Svchip_MotionInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_motion = /** @type {((inputs?: Svchip_MotionInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_MotionInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_motion(inputs)
	if (locale === "bn") return bn_svchip_motion(inputs)
	if (locale === "de") return de_svchip_motion(inputs)
	if (locale === "es") return es_svchip_motion(inputs)
	if (locale === "fr") return fr_svchip_motion(inputs)
	if (locale === "pt") return pt_svchip_motion(inputs)
	if (locale === "zh") return zh_svchip_motion(inputs)
	if (locale === "tr") return tr_svchip_motion(inputs)
	if (locale === "ru") return ru_svchip_motion(inputs)
	if (locale === "pl") return pl_svchip_motion(inputs)
	return en_svchip_motion(inputs)
});